import { getSitecoreTracker, getCookie, setCookie, UniformCookieNames } from '@uniformdev/tracking';
import { getNullLogger, getSubscriptionManager } from '@uniformdev/common';
var debugLogger = {
  debug: function debug(message, data) {
    console.log(new Date().toISOString() + " [Uniform Tracker  DEBUG] " + message, data);
  },
  error: function error(message, data) {
    console.log(new Date().toISOString() + " [Uniform Tracker  ERROR] " + message, data);
  },
  info: function info(message, data) {
    console.log(new Date().toISOString() + " [Uniform Tracker   INFO] " + message, data);
  },
  trace: function trace(message, data) {
    console.log(new Date().toISOString() + " [Uniform Tracker  TRACE] " + message, data);
  },
  warn: function warn(message, data) {
    console.log(new Date().toISOString() + " [Uniform Tracker   WARN] " + message, data);
  }
};
/**
 * Prepares the tracker and makes it available as a global JavaScript object.
 * No data is tracked when this function is called.
 * @param settings
 */
export function initializeTracker(settings) {
  var _a, _b;
  //
  //Add subscriptions.
  var addSubscription = function addSubscription(name, type) {
    if (!name) {
      return;
    }
    if (typeof window[name] !== "function") {
      debugLogger.error("Uniform tracking - doTracking - Unable to add a tracker subscription because the specified function does not exist.", {
        name: name,
        type: type
      });
      return;
    }
    var callback = window[name];
    if (callback) {
      subscriptions.subscribe(type, callback);
    }
  };
  var subscriptions = getSubscriptionManager();
  addSubscription(settings.onTrackingFinished, "tracking-finished");
  addSubscription(settings.onVisitUpdate, "visit-updated");
  addSubscription(settings.onVisitorUpdate, "visitor-updated");
  //
  //
  var args = {
    sessionTimeout: (_a = settings.sessionTimeout) !== null && _a !== void 0 ? _a : 20,
    storage: (_b = settings.storage) !== null && _b !== void 0 ? _b : "default",
    subscriptions: subscriptions,
    type: "js"
  };
  var logger = settings.debug == true ? debugLogger : getNullLogger();
  var tracker = getSitecoreTracker(args, logger);
  if (!tracker) {
    debugLogger.error("Uniform tracking - initializeTracker - No tracker was returned from getSitecoreTracker.", {
      args: args
    });
    return undefined;
  }
  //
  //Set the tracker on the global object.
  if (!window.uniform) {
    window.uniform = {};
  }
  window.uniform.tracker = tracker;
  return tracker;
}
/**
 * Tracks using tracking data from the global JavaScript object.
 * If the tracker is not already initialized, this function
 * initializes it.
 * @param settings
 */
export function doTracking(settings) {
  var _a, _b, _c;
  if (!window.uniform) {
    return;
  }
  var source = settings.source;
  if (!source) {
    debugLogger.error("Uniform tracking - doTracking - No source was specified.", {
      settings: settings
    });
    return;
  }
  var data = (_a = settings.data) !== null && _a !== void 0 ? _a : window.uniform;
  if (!data) {
    debugLogger.warn("Uniform tracking - doTracking - No tracking data was resolved.", {
      settings: settings
    });
    return;
  }
  var tracker = (_b = window.uniform.tracker) !== null && _b !== void 0 ? _b : initializeTracker(settings);
  if (!tracker) {
    debugLogger.error("Uniform tracking - doTracking - No tracker is available.", {
      settings: settings
    });
    return;
  }
  var cookie = (_c = settings.cookie) !== null && _c !== void 0 ? _c : UniformCookieNames.VisitorId;
  var visitorId = getCookie(cookie);
  var results = tracker.track(source, data, {
    visitorId: visitorId,
    createVisitor: true,
    silent: settings.silent
  });
  if (results && results.visitor) {
    setCookie(cookie, results.visitor.id);
  }
}